import { useToast } from '../../components/ui/ToastProvider'

export interface AddProjectAffordanceProps {
  /** Used only for the toast message ("Assign “<name>” to a project…") — a
   * human-readable order label, not an id. */
  readonly orderLabel: string
}

/**
 * The PROJECT column's "+ Add project" affordance (UID-132), rendered when an
 * order has no associated workspace/project. See `domain.ts`'s "PROJECT
 * column — DISCLOSED, GENUINE CONTRACT GAP" doc comment for the full
 * rationale: there is no `workspaceId`/`projectId` field anywhere on
 * `Order`/`OrderSummary`, so this is INERT by necessity, not by choice — a
 * real `<button>` styled to match the design's clickable-looking link
 * (`Fictiv Platform.dc.html` home `ordersTable` ~L462, `fx-navlink`), kept
 * for pixel fidelity, that shows an informational toast instead of writing
 * anything. `OrderTable` and `RecentOrders` both render this SAME component
 * so the inert behavior (and its copy) can never drift between the two
 * surfaces.
 */
export function AddProjectAffordance({ orderLabel }: AddProjectAffordanceProps) {
  const { showToast } = useToast()
  return (
    <button
      type="button"
      className="order-row-add-project"
      onClick={(event) => {
        event.stopPropagation()
        showToast(`Assigning “${orderLabel}” to a project isn’t available yet.`, 'info')
      }}
    >
      + Add project
    </button>
  )
}
